<template lang="pug">
  .container
    .info
      img.banner(src="../../assets/images/shaanxi/success.png")
      p 恭喜！办理成功
      //- p.color-red 恭喜获得五折开通爱奇艺会员
      //- p.point
      //-   | 原价
      //-   label.color-red 198元
      //-   | 年费会员，
      //-   label.color-red 99元
      //-   | 限时资格抢购!
      //- p.color-red 截图保存图片，微信扫一扫登录开通
      //- img.iqiyi(src="../../assets/images/chongqing/iqiyi.png")
      //- p.color-red 截图保存图片，微信扫一扫登录开通
</template>

<script>
export default {
  data() {
    return {
      shareNoticeVisiable: false,
      blAccount: 'meirxx'
    }
  },
  methods: {
    copyBLName() {
      let _range = document.createRange()
      _range.selectNode(this.$refs.blAccount)
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(_range);
      document.execCommand('Copy')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>

<style lang="less" scoped>
.info{
  font-size: 1.1rem;
  text-align: center;
  margin-top: 2rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  .bl{
    width: 90%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
img.iqiyi{
  width: 70%;
  margin-top: 1rem;
}
p{
  margin: .5rem 0;
}
.point{
  margin: 0 .7rem;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
</style>